<!-- Copyright 2026, Common Good Learning Tools LLC -->
<template>
	<div class="k-scram-job-stats" v-if="initialized">

		<div v-if="!has_resource_universe">{{ru_label}} Universe Not Specified</div>
		<div v-else class="ml-0">
			<div class="k-scram-job-stats-start">
				{{ru_label}} Universe Count: <b>{{n_resources}}</b>

				<k-btn small icon color="primary" style="margin-top:-4px"
					v-show="matrix"
					@click="$emit('edit_resources')"
				><k-icon small>fas fa-edit</k-icon></k-btn>
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{comps_per_resource}}</b> {{align_assoc_adj_uc}} {{cu_label}}s. per {{ru_label}}
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{n_resources_aligned}}</b> {{ru_label}}{{(n_resources_aligned==1)?'':'s'}} (<b>{{n_resources_aligned_percentage}}%</b>) {{align_assoc_adj}}
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{n_resources_not_aligned}}</b> {{ru_label}}{{(n_resources_not_aligned==1)?'':'s'}} (<b>{{n_resources_not_aligned_percentage}}%</b>) not {{align_assoc_adj}}
			</div>
		</div>

		<div v-if="!has_comp_universe" class="ml-8">{{cu_label}} Universe Not Specified</div>
		<div v-else class="ml-8">
			<div class="k-scram-job-stats-start">
				{{cu_label}} Universe Count: <b>{{n_comps}}</b> ({{n_branch_comps}})

				<k-btn small icon color="primary" style="margin-top:-4px"
					v-show="matrix"
					@click="$emit('edit_comps')"
				><k-icon small>fas fa-edit</k-icon></k-btn>
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{resources_per_comp}}</b> {{align_assoc_adj_uc}} {{ru_label}}s per {{cu_label}}
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{n_comps_aligned}}</b> {{cu_label}}{{(n_comps_aligned==1)?'':'s'}}. (<b>{{n_comps_aligned_percentage}}%</b>) {{align_assoc_adj}}
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{n_comps_not_aligned}}</b> {{cu_label}}{{(n_comps_not_aligned==1)?'':'s'}}. (<b>{{n_comps_not_aligned_percentage}}%</b>) not {{align_assoc_adj}}
			</div>
		</div>

		<div v-if="has_resource_universe && has_comp_universe" class="ml-8">
			<div class="k-scram-job-stats-start">
				Matrix Size: <b>{{matrix_stats.matrixCellCount}}</b>
			</div>
			<div v-show="matrix" class="mt-2">
				Total {{align_assoc_noun_uc}}s: <b>{{n_alignments}}</b>
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{n_sme_alignments}}</b> SME (<b>{{n_primary_alignments}}</b> Primary), <b>{{n_auto_alignments}}</b> Auto
			</div>
			<div v-show="matrix" class="mt-2">
				<b>{{n_not_aligned}}</b> Cell{{n_not_aligned!=1?'s':''}} marked Not {{align_assoc_adj_uc}}
			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SCRAMReportMixin from './SCRAMReportMixin.js'

export default {
	mixins: [SCRAMReportMixin,],
	components: { },
	props: {
		job_status_prop: { required: true },
		matrix_prop: { required: true },
	},
	data() { return {
	}},
	computed: {
		...mapState(['site_config', 'framework_records', 'user_info']),
		...mapGetters([]),
		initialized() {
			return this.job_status
		},

		has_resource_universe() {
			return true
			if (empty(this.job_status?.universe_params.resourceUniverse)) return false
			let arr = JSON.parse(this.job_status.universe_params.resourceUniverse)
			return arr[0] && !empty(arr[0].frameworkIdentifier)
		},

		has_comp_universe() {
			return true
			if (empty(this.job_status?.universe_params.competencyUniverse)) return false
			let arr = JSON.parse(this.job_status.universe_params.competencyUniverse)
			return arr[0] && !empty(arr[0].frameworkIdentifier)
		},

		n_resources() {
			return this.matrix_stats.resourceCount
		},
		n_comps() {
			return this.matrix_stats.competencyCount
		},
		n_branch_comps() {
			return this.matrix_stats.branchCompetencyCount
		},

		comps_per_resource() {
			if (this.n_alignments == 0) return '–'
			return (this.n_alignments / this.n_resources).toFixed(1)
		},
		n_resources_not_aligned() {
			return this.n_resources - this.n_resources_aligned
		},
		n_resources_aligned_percentage() {
			return Math.round(this.n_resources_aligned / this.n_resources * 100)
		},
		n_resources_not_aligned_percentage() {
			return Math.round(this.n_resources_not_aligned / this.n_resources * 100)
		},

		resources_per_comp() {
			if (this.n_alignments == 0) return '–'
			return (this.n_alignments / this.n_comps).toFixed(1)
		},
		n_comps_not_aligned() {
			return this.n_comps - this.n_comps_aligned
		},
		n_comps_aligned_percentage() {
			return Math.round(this.n_comps_aligned / this.n_comps * 100)
		},
		n_comps_not_aligned_percentage() {
			return Math.round(this.n_comps_not_aligned / this.n_comps * 100)
		},
	},
	watch: {
		job_status_prop: { immediate: true, deep:true, handler() {
			this.job_status = this.job_status_prop
		}},
		matrix_prop: { immediate: true, deep:true, handler() {
			this.matrix = this.matrix_prop
		}},
	},
	created() {
		vapp.scram_job_stats_component = this
	},
	async mounted() {
		
	},
	beforeDestroy() {
	},
	methods: {
		
	}
}
</script>

<style lang="scss">
.k-scram-job-stats {
	display:flex;
	justify-content: center;

	background-color:#eee;
	padding:8px;
	border-radius:8px;

	font-size:16px;
	line-height:19px;
}

.k-scram-job-stats-start {
	padding-bottom:8px;
	border-bottom:1px solid #444;
}
</style>
